import React from 'react';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

export default class RsvpDeclineModal extends React.Component {
  render () {
    return (
      <BootstrapModal
        {...this.props}
        ref="rsvpDeclineModal"
        header={
          this.props.header || <i className="ico ico-2x icon-confirmed-check" style={{ color: '#46bc93' }} />
        }
        body={
          <div className="attendee-decline-modal-container">
            <h3 className="text-center">
              <FormattedMessage
                id="invite.rsvp_decline_modal.declined_invite"
                defaultMessage="You declined {name}’s invite"
                values={{
                  name: this.props.guestFirstName
                }}
              />
            </h3>

            <div className="text-center">
              <button
                className="btn btn-primary classic"
                onClick={this.props.closeModal}
                style={{ width: '160px', marginBottom: '40px' }}
              >
                <FormattedMessage
                  id="invite.rsvp_decline_modal.button_done"
                  defaultMessage="Done"
                  values={{
                    name: this.props.guestFirstName
                  }}
                />
              </button>
            </div>
          </div>
        }
      />
    );
  }
}
